module.exports = __webpack_public_path__ + "static/media/locally_owned_logo.b1eb055b.png";